export var ItemVariant;

(function (ItemVariant) {
  ItemVariant["Primary"] = "primary";
  ItemVariant["Dark"] = "dark";
})(ItemVariant || (ItemVariant = {}));